<p-table *ngIf="!loading" [value]="rows">
  <ng-template pTemplate="header">
    <tr>
      <th *ngFor="let col of columns">{{ col }}</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-row>
    <tr>
      <td *ngFor="let cell of row">{{ cell }}</td>
    </tr>
  </ng-template>
</p-table>

<p-progressSpinner
  *ngIf="loading"
  styleClass="custom-spinner"
></p-progressSpinner>
